// @flow
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import ToolbarItems from './ToolbarItems';

export const ToolbarContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 15px;

  ${maxMediaQueries.phone`
    width: 100%;
    justify-content: space-between;
  `};
`;

type Props = {
  like?: {
    qty: number,
    action: Function,
    done: boolean,
    disable?: string
  },
  save?: {
    action: Function,
    done: boolean
  },
  respond?: {
    qty: number,
    id?: string | number,
    solved?: string,
    path?: string,
    action?: Function,
    disable?: string
  },
  select?: {
    action: Function,
    done: boolean,
    disable?: string
  },
  share?: {
    title: string,
    path: string
  },
  adviser?: {
    id: string,
    name: string
  }
};

export const Toolbar = (props: Props) => (
  <ToolbarContent>
    <ToolbarItems {...props} />
  </ToolbarContent>
);
